/**
 *  @class
 *  @function CartDiscounts
 */
if (!customElements.get('cart-discounts')) {
  class CartDiscounts extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      this.discounts();
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      }, {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    discounts() {
      const button = this.querySelector('.cart-discounts--button');
      const remove_discount_buttons = this.querySelectorAll('.cart-discounts--remove');

      if (!button) {
        return;
      }
      button.addEventListener('click', (event) => {
        if (this.closest('#Cart-Drawer') && (button.classList.contains('loading')
          || this.existingDiscounts().includes(this.querySelector('.cart-discounts--input').value))) {
          event.preventDefault();
          return;
        }
        this.updateDiscount();
        event.preventDefault();
        button.classList.add('loading');
      });
      remove_discount_buttons.forEach((remove_discount_button) => {
        remove_discount_button.addEventListener('click', this.removeDiscount.bind(this));
      });
    }
    updateDiscount() {
      const discountCode = this.querySelector('.cart-discounts--input');
      const discountCodeValue = discountCode.value;
      const existingDiscounts = this.existingDiscounts();

      if (existingDiscounts.includes(discountCodeValue)) return;
      existingDiscounts.push(discountCodeValue);

      this.renderDiscounts(existingDiscounts, discountCodeValue);
    }
    removeDiscount(event) {
      const pill = event.target.previousElementSibling;
      const discountCode = pill.innerHTML;
      const existingDiscounts = this.existingDiscounts();
      const index = existingDiscounts.indexOf(discountCode);
      if (index === -1) return;

      existingDiscounts.splice(index, 1);

      this.renderDiscounts(existingDiscounts);
    }
    existingDiscounts() {
      const discountCodes = [];
      const discountPills = this.querySelectorAll('.cart-discounts--name');
      for (const pill of discountPills) {
        discountCodes.push(pill.innerHTML);
      }

      return discountCodes;
    }
    renderDiscounts(existingDiscounts, discountCodeValue) {
      const drawer = this.closest('#Cart-Drawer');
      const currentDiscounts = () => drawer?.querySelector('cart-discounts') || this;
      const request = drawer ? (drawer.ivDiscountRequest = (drawer.ivDiscountRequest || 0) + 1) : 0;
      let rendered = false;
      const current = () => !drawer || (drawer.ivDiscountRequest === request && (this.isConnected || rendered));
      const body = JSON.stringify({
        discount: existingDiscounts.join(','),
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      this.querySelector('.cart-discounts--error').setAttribute('hidden', '');
      const finishExpressUpdate = ivBeginCartExpressUpdate();
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          if (drawer && !response.ok) throw new Error(`Status ${response.status}`);
          return response.text();
        })
        .then((state) => {
          if (!current()) return;
          const focusError = drawer?.classList.contains('active') && this.isConnected && this.contains(document.activeElement);
          const parsedState = JSON.parse(state);

          rendered = true;
          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections && elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              if (section.id === 'Cart-Drawer') elementToReplace.removeProductEvent?.();
            }
          }));
          currentDiscounts().querySelector('.cart-discounts--button').classList.remove('loading');
          if (parsedState.discount_codes.find((discount) => {
            return discount.code === discountCodeValue && discount.applicable === false;
          })) {
            if (drawer) {
              const active = currentDiscounts();
              const details = active.closest('details');
              if (details) details.open = true;
              active.querySelector('.cart-discounts--error').removeAttribute('hidden');
              if (focusError) {
                active.querySelector('.cart-discounts--input').focus({ preventScroll: true });
                active.querySelector('.cart-discounts--error').scrollIntoView({ block: 'nearest' });
              }
            } else {
              setTimeout(() => {
                this.querySelector('.cart-discounts--error').removeAttribute('hidden');
              }, 300);
            }
            return;
          }
        })
        .catch((error) => {
          if (!drawer) throw error;
          if (current()) drawer.ivMeldung?.();
        })
        .finally(() => {
          finishExpressUpdate();
          if (drawer && current()) currentDiscounts().querySelector('.cart-discounts--button')?.classList.remove('loading');
        });
    }
  }
  customElements.define('cart-discounts', CartDiscounts);
}

